import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import backBtn from "../../assets/icons/UpdatedCheckoutPage/backBtn.svg";
import AlphaTraderIcon from "../../assets/icons/AlphaTrader.svg";
import googlepay from "../../assets/PaymentIcons/Google_Pay_Logo.svg";
import "./UpdatedCheckoutPage.scss";
import {
  getChallenges,
  getUserBasicDetails,
} from "../../store/reducers/paymentReducer";
import {
  getUserProfile,
  LoadUser,
  sessionTimeout,
  addCurrentAccount,
} from "../../store/reducers/userProfileReducer";

import { dollarUS } from "../../utilities/formatters";
import { axiosInstance, baseUrl } from "../../Axios";

import radioActiveBtn from "../../assets/icons/UpdatedCheckoutPage/radioActiveBtn.svg";
import radioBtn from "../../assets/icons/UpdatedCheckoutPage/radioBtn.svg";
import zoomImg from "../../assets/icons/UpdatedCheckoutPage/zoomBtn.svg";
import InfoIcon from "../../assets/icons/UpdatedCheckoutPage/InfoIcon.svg";
import Logo from "../../assets/images/SignupImg/Logo.svg";
import PDFDoc from "../../assets/Docs/Alpha Capital Group - Terms and Conditions.pdf";
import { CHECKOUT_ALLOWED_COUNTRIES } from "../../constants/payments";
import {
  addGoogleTagScripts,
  addMetaScripts,
  // challenges,
  checkValidate,
  countries,
  CustomerInfoForm,
  CustomerInformation,
  handleApplyCoupon,
  HoverAccountTypeModal,
  paymentMethodDetails,
  paymentMethods,
  payout_type,
  PayoutTypeSelector,
  platformList,
  stripePaymentInitV4,
  freeTrialPaymentInitV4,
  TncModal,
  alphaProVariantOptions,
} from "./PaymentExports";
import { AcctokenD, login, RefftokenD } from "../../store/actions";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import ErrorModal from "../../reusableComponents/ErrorModal";
import axios from "axios";
import { DataPreviewModal } from "./PreviewModal";
import { message, Modal } from "antd";
import PDFPreview from "../../reusableComponents/PDFReview/PDFReview";

const UpdatedNewCheckoutPage = ({ publicCheckout = false }) => {
  const { challenge_id, coupon_code } = useParams();
  const challenges = useSelector((state) => state.payments.challenges || []); // Default to empty array
  const idToken = useSelector((state) => state.ACCtoken);
  const refresh_token = useSelector((state) => state.REFFtoken);
  const [selectedStep, setSelectedStep] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [selectedPayoutType, setSelectedPayoutType] = useState(2);
  const [selectedAcType, setSelectedAcType] = useState(1); // Index of selected account type
  const [useEA, setUseEA] = useState(false); // Boolean for EA use
  const ac_type = ["Raw spread", "No commission"];

  const [selectedChallenge_id, setSelectedChallenge_id] =
    useState(challenge_id);
  const navigate = useNavigate();
  useEffect(() => {
    if (!Array.isArray(challenges) || !challenge_id) {
      console.warn("Invalid challenges or challenge_id:", {
        challenges,
        challenge_id,
      });
      return;
    }

    const challengeIdNum = Number(challenge_id);

    for (const step of challenges) {
      if (!step?.plans || !Array.isArray(step.plans)) continue;

      for (const plan of step.plans) {
        if (!plan?.challenges || !Array.isArray(plan.challenges)) continue;

        const matchingChallenge = plan.challenges.find(
          (challenge) => Number(challenge?.id) === challengeIdNum,
        );

        if (matchingChallenge) {
          setSelectedChallenge_id(matchingChallenge?.id);
          setSelectedChallenge(matchingChallenge);
          // setSelectedPayoutType(matchingChallenge?.payout_type);
          setSelectedStep(step);
          setSelectedPlan(plan);
          return;
        }
      }
    }

    console.warn(`No challenge found for ID: ${challengeIdNum}`);
  }, [challenges, challenge_id]);

  // Reset selectedPlan and selectedChallenge when selectedStep changes
  useEffect(() => {
    if (
      selectedStep &&
      (!selectedPlan || !selectedStep.plans.includes(selectedPlan))
    ) {
      setSelectedPlan(selectedStep.plans?.[0] || null);
    }
  }, [selectedStep]);

  useEffect(() => {
    if (
      selectedPlan &&
      (!selectedChallenge ||
        !selectedPlan.challenges.includes(selectedChallenge))
    ) {
      setSelectedChallenge(selectedPlan.challenges?.[0] || null);
      setSelectedChallenge_id(selectedPlan.challenges?.[0]?.id || null);
      // setSelectedPayoutType(selectedPlan.challenges?.[0]?.payout_type);
    }
  }, [selectedPlan]);

  // platform

  // Example state (adjust as needed)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedCrypto, setSelectedCrypto] = useState(null);
  const radioGroupRef = useRef(null);

  const [countryCheck, setCountryCheck] = useState(""); // Examplezz\
  // Example variables (replace with your actual logic)
  const countryCheckingReq = async () => {
    try {
      let url = `check/country/`;
      const { data, status } = await axiosInstance.get(url);
      if (status < 399) {
        const country = data?.country;
        const isCheckoutAllowed = CHECKOUT_ALLOWED_COUNTRIES.includes(country);

        setSelectedPaymentMethod(isCheckoutAllowed ? "checkout" : "nuvei");
        setCountryCheck(country);
        setSelectedCrypto(null);
        
        // Set default platform based on country
        if (country === "US") {
          // For US, default to ctrader
          const ctraderPlatform = platformList.find(p => p.value === "ctrader");
          setSelectedPlatform(ctraderPlatform || platformList[0]);
        } else {
          // For other countries, default to MT5 (first in list)
          setSelectedPlatform(platformList[0]);
        }
      }
    } catch (error) {
      console.log(error.response?.data || error.message);
      // throw error.response?.data || error.message;
    }
  };
  useEffect(() => {
    countryCheckingReq();
  }, []);

  // Reset EA setting when platform is changed to non-MT5
  useEffect(() => {
    if (selectedPlatform?.value && selectedPlatform.value !== "mt5") {
      setUseEA(false);
    }
  }, [selectedPlatform?.value]);

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [confirmPaymentClick, setConfirmPaymentClick] = useState(false);
  const [basicDetailsDisabled, setBasicDetailsDisabled] = useState({});
  const [basicDetails, setBasicDetails] = useState({
    first_name: "",
    last_name: "",
    email: "",
    contact: "",
    Country: "",
    City: "",
    country_code: "",
    confirmEmail: "",
  });
  const [countryCode, setCountryCode] = useState(null);

  const anonymous = false;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        // Fetch challenges
        const challengesRes = await dispatch(getChallenges());
        // Add logic here if you need to use challengesRes

        if (!anonymous && !publicCheckout) {
          // Fetch user details
          const userRes = await dispatch(getUserBasicDetails());
          const updatedDetails = {
            ...userRes,
            contact: userRes?.Contact_number,
          };
          setBasicDetails(updatedDetails);
          setBasicDetailsDisabled({
            first_name: userRes?.first_name && true,
            last_name: userRes?.last_name && true,
            email: userRes?.email && true,
            contact: userRes?.Contact_number && true,
            Country:
              countries.find((item) => item.label === userRes?.Country) && true,
            City: userRes?.City && true,
            country_code: userRes?.country_code && true,
          });

          // Find country
          const countryString = String(userRes.country_code).toLowerCase();
          const country = countries.find(
            (item) =>
              item.label.toLowerCase() === countryString ||
              item.phone.toLowerCase() === countryString,
          );
          if (country) setCountryCode(country);

          // Load user
          await dispatch(LoadUser());
        }

        // Add scripts
        addGoogleTagScripts();
        addMetaScripts();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  const [finalPrice, setFinalPrice] = useState({});
  const [isCheckedError, setIsCheckedError] = useState("");
  const [isChecked, setIsChecked] = React.useState({
    tnc: false,
    not_us_resident: false,
    acknowledge_personal_data: false,
    agree_to_news_letters: false,
  });
  const [coupon, setCoupon] = useState({
    value: coupon_code || null,
    error: false,
  });
  const [alphaProVariant, setAlphaProVariant] = useState(8);
  const [isCouponLoading, setIsCouponLoading] = useState(false);
  const prevPayoutTypeRef = useRef(selectedPayoutType);
  const prevChallengeIdRef = useRef(selectedChallenge_id);
  const applyCoupon = useCallback(
    async (alphaProVariant, selectedPayoutType, passedCoupon) => {
      try {
        setIsCouponLoading(true);
        const result = await handleApplyCoupon(
          { value: passedCoupon ?? coupon.value }, // No 'error' field needed here!
          selectedStep?.step === "Step 2" &&
            selectedPlan.plan_type === "Alpha pro"
            ? alphaProVariant
            : null,
          selectedPayoutType,
          selectedChallenge_id,
          idToken,
          setFinalPrice,
          // FIX: correctly update only error, preserving other properties!
          (error) => setCoupon((prev) => ({ ...prev, error })),
          publicCheckout,
          selectedPlatform?.value,
        );
        console.log("Coupon applied successfully:", result);
      } catch (err) {
        console.log("Error applying coupon:", err);
      } finally {
        setIsCouponLoading(false);
      }
    },
    [
      coupon,
      selectedStep?.step,
      selectedChallenge_id,
      idToken,
      publicCheckout,
      selectedPlan,
      selectedPlatform?.value,
    ],
  );

  // Add a ref to track if coupon was already applied
  const hasAppliedCoupon = useRef(false);

  const stepOneChallenges =
    challenges
      .find((item) => item.step === 1)
      ?.plans.find((plan) => plan.plan_type === "Alpha One")
      ?.challenges.map((challenge) => challenge.id) || [];

  const isNotStepOne = !stepOneChallenges.includes(selectedChallenge_id);

  // Reset hasAppliedCoupon when challenge ID, alphaProVariant, or selectedPayoutType changes
  useEffect(() => {
    hasAppliedCoupon.current = false;
  }, [selectedChallenge_id, alphaProVariant, selectedPayoutType, isNotStepOne]);
  useEffect(() => {
    setCoupon({
      value: coupon_code || null,
      error: false,
    });
  }, [selectedChallenge_id, coupon_code]);
  useEffect(() => {
    // Only run if coupon hasn't been applied yet and it's not a step one challenge
    if (
      (selectedPlan?.plan_type.toLowerCase() === "alpha pro" ||
        selectedPlan?.plan_type.toLowerCase() === "alpha three") &&
      !hasAppliedCoupon.current &&
      isNotStepOne
    ) {
      applyCoupon(alphaProVariant, selectedPayoutType);
      hasAppliedCoupon.current = true; // Mark as applied
    }
  }, [
    selectedPlan?.plan_type,
    alphaProVariant,
    selectedPayoutType,
    selectedChallenge_id,
    isNotStepOne,
    applyCoupon,
  ]);
  useEffect(() => {
    if (coupon.value === "") applyCoupon(alphaProVariant, selectedPayoutType);
  }, [coupon.value]);
  useEffect(() => {
    if (
      selectedPlan?.plan_type &&
      ["Alpha pro", "Alpha Pro"].includes(selectedPlan.plan_type) &&
      [6, 8, 10].includes(alphaProVariant) &&
      selectedPlan.challenges?.length
    ) {
      const match = selectedPlan.challenges.find(
        (challenge) => challenge.profit_target_in_percent === alphaProVariant,
      );
      if (match) {
        setSelectedChallenge(match);
        setSelectedChallenge_id(match.id);
      }
    }
  }, [selectedPlan, alphaProVariant]);

  const handleCouponClick = () => {
    applyCoupon(alphaProVariant, selectedPayoutType);
    hasAppliedCoupon.current = true; // Mark as applied when clicked
  };

  // Reset hasAppliedCoupon when plan changes
  useEffect(() => {
    hasAppliedCoupon.current = false;
  }, [selectedPlan?.plan_type]);

  const payload = {
    refresh_token: refresh_token,
    payment_method: selectedPaymentMethod,
    challenge_id: selectedChallenge_id,
    coupon: coupon?.value,
    email: basicDetails?.email,
    confirmEmail: basicDetails?.email,
    first_name: basicDetails?.first_name,
    last_name: basicDetails?.last_name,
    contact: basicDetails?.contact,
    // payout_type: selectedStep?.step !== "Step 1" ? selectedPayoutType : 2,
    payout_type:
      selectedPlan?.plan_type?.toLowerCase() === "swing"
        ? 2
        : selectedStep?.step !== "Step 1"
          ? selectedPayoutType
          : 2,
    cryptocurrency: selectedCrypto,
    ...(selectedPlan?.plan_type === "Alpha pro"
      ? { alpha_pro_variant: alphaProVariant }
      : {}),

    country_code: countryCode?.code,
    raw_spread: selectedAcType === 0 ? true : null,
    platform: selectedPlatform?.value,
    EAs: useEA ? true : null,
  };
  console.log(
    selectedPlan?.plan_type,
    "selectedPlan?.plan_typeselectedPlan?.plan_type",
  );
  const [allErrors, setAllErrors] = useState({});
  const [isError, setIsError] = useState();
  const [previewData, setPreviewData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const accountPreview = async () => {
    const checkAllTrue = () => {
      const requiredKeys = [
        "tnc",
        ...(countryCheck !== "US" &&
        selectedPlatform.value !== "dxtrade" &&
        selectedPlatform.value !== "tradelocker" &&
        selectedPlatform.value !== "ctrader"
          ? ["not_us_resident"]
          : []),
        "acknowledge_personal_data",
      ];
      return requiredKeys.every((key) => isChecked[key] === true);
    };
    // Validate basic details
    const validationResult = checkValidate(basicDetails, publicCheckout);
    if (!validationResult?.isValid) {
      setAllErrors(
        validationResult?.errors || { general: "Validation failed" },
      );
      return;
    }

    // Check terms and conditions
    if (!checkAllTrue()) {
      setIsCheckedError("Please accept all required terms and conditions.");
      return;
    }

    try {
      setConfirmPaymentClick(true);

      const accountPreview = await axios.post(
        `${baseUrl}/payment/account-preview/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        },
      );
      if (accountPreview.status === 200) {
        setPreviewData(accountPreview?.data);
        setIsModalVisible(true);
      } else {
        message.error("Failed to fetch account preview. Please try again.");
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        message.error(
          error.response?.data?.message ||
          "Failed to fetch account preview. Server error occurred.",
        );
      } else {
        message.error("An unexpected error occurred. Please try again.");
      }

      console.error("Account preview error:", error);
    } finally {
      setConfirmPaymentClick(false);
    }
  };

  const handleFinalCheckout = async () => {
    try {
      setConfirmPaymentClick(true);
      // Update user profile only if not public checkout
      if (!publicCheckout) {
        const profilePayload = {
          first_name: basicDetails.first_name,
          last_name: basicDetails.last_name,
          Contact_number: basicDetails.contact,
          Country: basicDetails.Country,
          City: basicDetails.City,
          country_code: basicDetails?.country_code
            ? Number(String(basicDetails.country_code).replace("-", ""))
            : null,
        };

        await axios
          .post(`${baseUrl}/v2/user/profile/create/`, profilePayload, {
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })
          .catch((error) => {
            if (
              error.response?.status === 400 &&
              error.response?.data?.Contact_number
            ) {
              // Handle duplicate phone number error
              setBasicDetails((prev) => ({
                ...prev,
                contactError:
                  error.response.data.Contact_number[0] ||
                  "This phone number is already in use.",
              }));
              setConfirmPaymentClick(false);
              // Scroll to the contact field for better UX
              document
                .getElementById("contact-input")
                ?.scrollIntoView({ behavior: "smooth" });
              throw new Error("Phone number already in use");
            }
            throw error; // Re-throw other errors
          });
      }

      // Handle free trial case
      if (selectedPlan?.plan_type === "Free Trial") {
        const freeTrialPayload = {
          challenge: selectedChallenge_id,
          raw_spread: selectedAcType === 0,
          platform: selectedPlatform?.value,
          EAs: useEA,
          email: basicDetails?.email,
        };

        const response = await freeTrialPaymentInitV4(
          dispatch,
          freeTrialPayload,
          idToken,
          publicCheckout,
        );

        if (response?.data?.success) {
          if (response.auth) {
            dispatch(AcctokenD(response.auth.idToken));
            dispatch(RefftokenD(response.auth.refresh_token));
            dispatch(sessionTimeout(false));
            await dispatch(getUserProfile());
            dispatch(login());
          }
          dispatch(addCurrentAccount({ login_id: response.data.login }));
          navigate("/AccountMetric");
        } else {
          throw new Error("Failed to create free trial account");
        }
        return;
      }

      // Process payment for non-free trial cases

      // Process payment
      const response = await stripePaymentInitV4(
        dispatch,
        payload,
        idToken,
        publicCheckout,
      );

      if (!response) {
        throw new Error("No response received from payment service");
      }

      // Handle authentication
      if (response.auth) {
        try {
          dispatch(AcctokenD(response.auth.idToken));
          dispatch(RefftokenD(response.auth.refresh_token));
          dispatch(sessionTimeout(false));

          await dispatch(getUserProfile());
          dispatch(login());
        } catch (authError) {
          console.error("Authentication processing error:", authError);
          setIsError("Authentication failed. Please try again.");
          return;
        } finally {
          setConfirmPaymentClick(false);
        }
      }

      // Handle redirect
      if (response?.url) {
        window.location.href = response.url;
      } else {
        console.warn("No redirect URL provided in response");
      }
    } catch (error) {
      // Determine specific error message
      let errorMessage = "An unexpected error occurred during checkout.";
      if (error.message?.includes("payment")) {
        errorMessage = "Payment processing failed. Please try again.";
      } else if (error.message?.includes("network")) {
        errorMessage = "Network error. Please check your connection.";
      } else {
        errorMessage = error?.message || error?.detail || error[0];
      }

      setIsError(errorMessage);
    } finally {
      setConfirmPaymentClick(false);
    }
  };

  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const [showTnc, setShowTnc] = useState(false);

  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const screenWidth = window.innerWidth;
      setScale(screenWidth < 750 ? 0.5 : 1);
    };

    updateScale(); // Set on initial load
    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, []);
  useEffect(() => {
    if (
      coupon_code &&
      !hasAppliedCoupon.current &&
      selectedChallenge_id &&
      selectedPlan &&
      selectedPayoutType !== undefined
    ) {
      setTimeout(() => {
        // Pass coupon_code directly to applyCoupon
        applyCoupon(alphaProVariant, selectedPayoutType, coupon_code);
        hasAppliedCoupon.current = true;
        setCoupon((pre) => ({ ...pre, value: coupon_code }));
      }, 0);
    }
    // eslint-disable-next-line
  }, [coupon_code, selectedChallenge_id, selectedPlan, selectedPayoutType]);
  useEffect(() => {
    console.log(coupon, "actual_priceactual_price");
  }, [coupon]);

  // 1. Add state for Crypto Confirmation Modal
  const [showCryptoModal, setShowCryptoModal] = useState(false);

  // 2. Modify handlePaymentMethod
  const handlePaymentMethod = (method) => {
    if (method === "coinspayment") {
      // If user selects crypto, show the warning modal first
      setShowCryptoModal(true);
    } else {
      // Otherwise set the method immediately
      setSelectedPaymentMethod(method);
    }
  };

  // 3. Handle Confirm (User clicks OK)
  const handleCryptoConfirm = () => {
    setSelectedPaymentMethod("coinspayment");
    setShowCryptoModal(false);
  };

  // 4. Handle Cancel (User clicks Cancel)
  const handleCryptoCancel = () => {
    setShowCryptoModal(false);

    // Logic to revert to the first valid payment method based on your country logic
    const isCheckoutAllowed = CHECKOUT_ALLOWED_COUNTRIES.includes(countryCheck);
    const firstMethod = isCheckoutAllowed ? "checkout" : "nuvei";

    // Only switch if we aren't already on a valid method (optional, but ensures "back to first" behavior)
    if (selectedPaymentMethod !== firstMethod) {
      setSelectedPaymentMethod(firstMethod);
    }
  };
  return (
    <div className="UpdatedCheckoutPage_main">
      <Modal
        title="Crypto Payment Warning"
        open={showCryptoModal}
        onOk={handleCryptoConfirm}
        onCancel={handleCryptoCancel}
        okText="Proceed"
        cancelText="Cancel"
        centered
        okButtonProps={{ danger: true }} // Optional: makes the proceed button red to indicate caution
        style={{
          maxWidth: "600px",
          backgroundColor:
            "var(--Box-BG, linear-gradient(103deg, rgba(184, 230, 255, 0.03) 0%, rgba(184, 230, 255, 0.07) 100%))",
        }}
      >
        <p style={{ fontSize: "16px", lineHeight: "1.5", color: "white" }}>
          <p>You are proceeding with a cryptocurrency payment.</p>{" "}
          <p>
            Please ensure that the correct coin,{" "}
            <strong>ETH, USDC, or USDT</strong>, is sent on the correct network,{" "}
            <strong>ERC20 (Ethereum network) or TRC20 (TRON network).</strong>
          </p>
          Sending the wrong coin or using the wrong network will result in the
          automation not working and your account not being delivered, and funds
          may also be lost. <strong>Please proceed with caution.</strong>
        </p>
      </Modal>
      <DataPreviewModal
        data={previewData || {}}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        onConfirm={handleFinalCheckout}
      />
      {isError && (
        <ErrorModal
          setModalOpen={setIsError}
          btnText={"close"}
          desc={isError}
        />
      )}
      <div className="UpdatedCheckoutPage_main_logo">
        <img src={Logo} alt="Logo" />
      </div>
      {!publicCheckout && (
        <div
          style={{ cursor: "pointer" }}
          className="backBtnContainer"
          onClick={() => navigate("/dashboard")}
        >
          <img style={{ width: "20px" }} src={backBtn} alt="backBtn" />
          Back
        </div>
      )}
      <div className="UpdatedCheckoutPage_left_right_sec">
        <div className="account_balance">
          <div className="account_balance_inner">
            <div className="platform">
              <div className="heading">
                <h1
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  Step
                </h1>
              </div>
              <div className="platform_main">
                {challenges.map((step) => (
                  <label
                    key={step?.step || step?.step} // Ensure unique key
                    onClick={() => {
                      if (step?.step === "Step 1" || step?.step === 1) {
                        setSelectedPayoutType(2);
                      }
                      setSelectedStep(step);
                      setFinalPrice({});
                    }}
                    className={`platform_box ${
                      selectedStep?.step === step?.step
                        ? "active_label selected_box"
                        : ""
                      }`}
                  >
                    <img
                      src={
                        selectedStep?.step === step?.step
                          ? radioActiveBtn
                          : radioBtn
                      }
                      alt="radio"
                    />
                    <p>{step?.step}</p>
                  </label>
                ))}
              </div>

              {selectedStep && (
                <div className="user_ac_type">
                  <div className="account_balance_header">
                    <h2>Account Type</h2>
                  </div>
                  <div className="user_ac_type_inner">
                    {selectedStep.plans?.map((plan, index) => {
                      return (
                        <>
                          <label
                            htmlFor={`plan-${index}`}
                            key={plan?.plan_type || index}
                            className={`ac_type_option ${
                              plan?.plan_type === selectedPlan?.plan_type
                                ? "active_label"
                                : ""
                              }`}
                            onClick={() => {
                              setSelectedPlan(plan);
                              setFinalPrice({});
                              if (
                                plan?.plan_type.toLowerCase() === "free trial"
                              ) {
                                // For free trial, always use MT5
                                setSelectedPlatform(platformList[0]);
                                setUseEA(false);
                              }
                            }}
                          >
                            <div className="label_inner_div">
                              <img
                                src={
                                  plan?.plan_type === selectedPlan?.plan_type
                                    ? radioActiveBtn
                                    : radioBtn
                                }
                                alt="radio"
                              />
                              <p>{plan?.plan_type || "Unnamed Plan"}</p>
                              <input
                                type="radio"
                                id={`plan-${index}`}
                                name="fundingEval"
                                value={plan?.plan_type || ""}
                                checked={
                                  plan?.plan_type === selectedPlan?.plan_type
                                }
                                readOnly
                                style={{ display: "none" }}
                              />
                            </div>
                            <img
                              src={InfoIcon}
                              alt="InfoIcon"
                              onMouseEnter={() =>
                                setShowAccountInfo(plan?.plan_type)
                              }
                              onMouseLeave={() => setShowAccountInfo(null)}
                            />
                            {showAccountInfo === plan?.plan_type && (
                              <HoverAccountTypeModal
                                isOpen={showAccountInfo}
                                onClose={() => setShowAccountInfo(null)}
                                challengeData={plan?.challenges}
                                fundingEval={plan?.plan_type}
                                selectedPayoutType={selectedPayoutType}
                                alphaProVariant={alphaProVariant}
                              />
                            )}
                          </label>
                        </>
                      );
                    })}
                  </div>
                </div>
              )}
              {selectedPlan?.plan_type?.toLowerCase() === "alpha pro" && (
                <div className="platform">
                  <div className="heading">
                    <h1
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      Assessment Target & Limits
                    </h1>
                  </div>
                  <div className="platform_main">
                    {alphaProVariantOptions.map((option, index) => (
                      <label
                        onClick={() => setAlphaProVariant(option?.value)}
                        key={option?.value || index}
                        className={`platform_box ${
                          alphaProVariant === option.value
                            ? "active_label selected_box"
                            : ""
                          }`}
                      >
                        <img
                          src={
                            alphaProVariant === option.value
                              ? radioActiveBtn
                              : radioBtn
                          }
                          alt={
                            alphaProVariant === option.value
                              ? "Selected"
                              : "Unselected"
                          }
                        />
                        <p>{option?.label}</p>
                        <img
                          src={InfoIcon}
                          alt="InfoIcon"
                          style={{ marginLeft: "auto" }}
                          onMouseEnter={() => setShowAccountInfo(option?.value)}
                          onMouseLeave={() => setShowAccountInfo(null)}
                        />
                        {showAccountInfo === option?.value && (
                          <HoverAccountTypeModal
                            isOpen={showAccountInfo}
                            onClose={() => setShowAccountInfo(null)}
                            challengeData={selectedChallenge}
                            fundingEval={selectedPlan}
                            selectedPayoutType={selectedPayoutType}
                            alphaProVariant={option?.value}
                          />
                        )}
                      </label>
                    ))}
                  </div>
                </div>
              )}
              {selectedPlan && (
                <div className="accountSize">
                  <div className="account_balance_header">
                    <h2>Account Size</h2>
                  </div>
                  <div className="amount_list">
                    {selectedPlan.challenges?.length > 0 ? (
                      selectedPlan.challenges.map((challenge, index) => {
                        const isAlphaPro = ["Alpha pro", "Alpha Pro"].includes(
                          selectedPlan.plan_type,
                        );

                        let showChallenge = true;

                        if (isAlphaPro && alphaProVariant) {
                          if ([10, 8].includes(alphaProVariant)) {
                            showChallenge =
                              challenge.profit_target_in_percent === 8;
                          } else if (alphaProVariant === 6) {
                            showChallenge =
                              challenge.profit_target_in_percent === 6;
                          } else {
                            showChallenge = false;
                          }
                        }

                        if (!showChallenge) return null;

                        const isSelected =
                          challenge?.id === selectedChallenge?.id;

                        return (
                          <label
                            htmlFor={`challenge-${challenge?.id || index}`}
                            key={challenge?.id || index}
                            className={`amount_box ${
                              isSelected ? "active_label selected_box" : ""
                              }`}
                            onClick={() => {
                              setFinalPrice({});
                              setSelectedChallenge(challenge);
                              setSelectedChallenge_id(challenge?.id);
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "10px",
                              }}
                            >
                              <img
                                src={isSelected ? radioActiveBtn : radioBtn}
                                alt="radio"
                              />
                              <p>{dollarUS(challenge?.account_balance || 0)}</p>
                              <input
                                type="radio"
                                name="account_balance_value"
                                id={`challenge-${challenge?.id || index}`}
                                checked={isSelected}
                                readOnly
                                style={{ display: "none" }}
                              />
                            </div>
                          </label>
                        );
                      })
                    ) : (
                      <p>No challenges available</p>
                    )}
                  </div>
                </div>
              )}
              <div className="platform">
                <div className="account_balance_header">
                  <h2>Platform</h2>
                </div>
                <div className="platform_main">
                  {platformList
                    ?.filter((platform) => {
                      // If the selected plan is a free trial, only include mt5
                      if (
                        selectedPlan?.plan_type?.toLowerCase() === "free trial"
                      ) {
                        return platform.value === "mt5";
                      }
                      return true; // Otherwise, include all platforms
                    })
                    .map((platform, index) => (
                      <label
                        key={platform?.value || index} // Unique key using value or index
                        htmlFor={`platform-${platform?.value || index}`} // Unique ID
                        className={`platform_box ${
                          platform?.value === selectedPlatform?.value
                            ? "active_label selected_box"
                            : ""
                          }`}
                        onClick={() => setSelectedPlatform(platform)}
                        style={{
                          pointerEvents: platform.disabled ? "none" : "auto",
                        }}
                      >
                        <img
                          src={
                            platform.disabled
                              ? AlphaTraderIcon
                              : platform?.value === selectedPlatform?.value
                                ? radioActiveBtn
                                : radioBtn
                          }
                          alt="radio"
                        />
                        <p style={{ color: platform?.disabled && "#757575" }}>
                          {platform?.name || "Unnamed Platform"}
                        </p>
                        <input
                          type="radio"
                          name="platform_type"
                          id={`platform-${platform?.value || index}`}
                          checked={platform?.value === selectedPlatform?.value}
                          style={{
                            display: "none",
                            pointerEvents: platform.disabled ? "none" : "auto",
                          }}
                          onChange={() => {}}
                        />
                        {platform.disabled && (
                          <div className="is-comming">Coming Soon</div>
                        )}
                      </label>
                    ))}
                </div>
              </div>
              <div className="confirm_order">
                <div className="account_balance_header">
                  <h2>Payment Method</h2>
                </div>
                <div className="order_option">
                  <div
                    className="paymentMethodSelectorBox"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "15px",
                    }}
                  >
                    {paymentMethods
                      .filter((method) => {
                        const isCheckoutAllowed =
                          CHECKOUT_ALLOWED_COUNTRIES.includes(countryCheck);

                        return isCheckoutAllowed
                          ? method.value === "checkout" ||
                          method.value === "coinspayment"
                          : method.value === "nuvei" ||
                          method.value === "coinspayment";
                      })
                      .map((method) => (
                        <div
                          key={method.value}
                          id={method.value}
                          onClick={() => handlePaymentMethod(method.value)}
                          className={`payment-option ${
                            selectedPaymentMethod === method.value
                              ? "active"
                              : ""
                            } ${method.value !== "coinspayment" ? "nuvei" : ""}`}
                        >
                          <label
                            htmlFor={`${method.value}-radio`}
                            className={`payment-label ${
                              selectedPaymentMethod === method.value
                                ? "payments-active_new active_label"
                                : ""
                              }`}
                          >
                            <div className="payment-logo-container">
                              <img
                                src={
                                  selectedPaymentMethod === method.value
                                    ? radioActiveBtn
                                    : radioBtn
                                }
                                alt="radio"
                              />
                              <input
                                type="radio"
                                id={`${method.value}-radio`}
                                name="payment_method"
                                checked={selectedPaymentMethod === method.value}
                                onChange={() =>
                                  handlePaymentMethod(method.value)
                                }
                                style={{ display: "none" }}
                              />
                              <p>{method.name}</p>
                            </div>
                            <img
                              src={paymentMethodDetails[method.value]?.icon}
                              style={{ height: "23px", width: "23px" }}
                              alt={method.name}
                              className="payment-logo"
                            />
                          </label>
                          {paymentMethodDetails[method.value]?.supported
                            .length > 0 && (
                              <div className="combined_payments">
                                {paymentMethodDetails[method.value].supported.map(
                                  (icon, idx) => (
                                    <img
                                      key={idx}
                                      src={icon}
                                      alt={`${method.name} supported method`}
                                      style={
                                        icon === googlepay
                                          ? { width: "30px" }
                                          : undefined
                                      }
                                    />
                                  ),
                                )}
                              </div>
                            )}
                        </div>
                      ))}
                  </div>
                </div>
                {["alpha pro", "alpha three"].includes(
                  selectedPlan?.plan_type?.toLowerCase(),
                ) && (
                    <PayoutTypeSelector
                      payout_type={payout_type}
                      selectedPayoutType={selectedPayoutType}
                      setSelectedPayoutType={setSelectedPayoutType}
                    />
                  )}
                <div className="commission_EA_use">
                  <div className="commission">
                    <div className="account_balance_header">
                      <h2>Commission</h2>
                    </div>
                    <div className="commission_inner">
                      {ac_type?.map((type, index) => (
                        <label
                          key={index} // Use index as key if types are unique; otherwise, use a unique ID
                          htmlFor={`ac-type-${index}`}
                          onClick={() => setSelectedAcType(index)}
                          className={`platform_box ${
                            selectedAcType === index
                              ? "active_label selected_box"
                              : ""
                            }`}
                        >
                          <img
                            src={
                              selectedAcType === index
                                ? radioActiveBtn
                                : radioBtn
                            }
                            alt="radio"
                          />
                          <p>{type || "Unnamed Type"}</p>
                          <input
                            type="radio"
                            name="commission_type"
                            id={`ac-type-${index}`}
                            checked={selectedAcType === index}
                            onChange={() => setSelectedAcType(index)}
                            style={{ display: "none" }} // Hide input, rely on image
                          />
                        </label>
                      ))}
                    </div>
                  </div>

                  {selectedPlatform?.value === "mt5" && (
                    <div className="EA_use">
                      <div className="account_balance_header">
                        <h2>EA Use</h2>
                      </div>
                      <div className="EA_use_inner">
                        <label
                          htmlFor="ea-yes"
                          onClick={() => setUseEA(true)}
                          className={`platform_box ${useEA ? "active_label selected_box" : ""
                            }`}
                        style={{
                          opacity:
                            selectedPlan?.plan_type?.toLowerCase() ===
                              "free trial"
                              ? 0.5
                              : 1,
                          cursor:
                            selectedPlan?.plan_type?.toLowerCase() ===
                              "free trial"
                              ? "not-allowed"
                              : "pointer",
                          pointerEvents:
                            selectedPlan?.plan_type?.toLowerCase() ===
                              "free trial"
                              ? "none"
                              : "auto",
                          }}
                        >
                          <img
                            src={useEA ? radioActiveBtn : radioBtn}
                            alt="radio"
                          />
                          <p>Yes</p>
                          <input
                            type="radio"
                            name="ea_use"
                            id="ea-yes"
                            checked={useEA}
                            onChange={() => setUseEA(true)}
                            style={{ display: "none" }}
                          />
                        </label>

                        <label
                          htmlFor="ea-no"
                          onClick={() => setUseEA(false)}
                          className={`platform_box ${
                            !useEA ? "active_label selected_box" : ""
                            }`}
                        >
                          <img
                            src={!useEA ? radioActiveBtn : radioBtn}
                            alt="radio"
                          />
                          <p>No</p>
                          <input
                            type="radio"
                            name="ea_use"
                            id="ea-no"
                            checked={!useEA}
                            onChange={() => setUseEA(false)}
                            style={{ display: "none" }}
                          />
                        </label>
                      </div>
                    </div>
                  )}
                </div>
                {showTnc && (
                  <TncModal open={showTnc} onClose={() => setShowTnc(false)} />
                )}
                <TncModal open={showTnc} onClose={() => setShowTnc(false)} />

                <CustomerInfoForm
                  publicCheckout={publicCheckout}
                  basicDetails={basicDetails}
                  setBasicDetails={setBasicDetails}
                  basicDetailsDisabled={basicDetailsDisabled}
                  checkValidate={checkValidate}
                  allErrors={allErrors}
                />
              </div>
            </div>
            <div
              className="termsCondition"
              style={{ width: "100%", height: "100%" }}
            >
              <p>Terms and Conditions</p>
              <div className="zoomBtn" onClick={() => setShowTnc(!showTnc)}>
                <button>
                  <img src={zoomImg} alt="Zoom" />
                </button>
              </div>
              <div className="termWrapper">
                <PDFPreview
                  fileUrl={PDFDoc}
                  style={{ height: "400px" }}
                  defaultScale={scale}
                />
              </div>
            </div>
          </div>
        </div>
        <CustomerInformation
          selectedPlan={selectedPlan}
          selectedChallenge={selectedChallenge}
          selectedPlatform={selectedPlatform}
          selectedPayoutType={selectedPayoutType}
          coupon={coupon}
          setCoupon={setCoupon}
          finalPrice={finalPrice}
          setFinalPrice={setFinalPrice}
          validateCouponCode={handleCouponClick}
          removeCoupon={false}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          setShowTNC={setShowTnc}
          handleNavigationLinks={(url) => window.open(url, "_blank")}
          countryCheck={countryCheck}
          confirmPaymentClick={confirmPaymentClick}
          handleFinalPayment={accountPreview} //handleFinalCheckout
          dollarUS={dollarUS}
          isCheckedError={isCheckedError}
          setIsCheckedError={setIsCheckedError}
          isCouponLoading={isCouponLoading}
          alphaProVariant={alphaProVariant}
          setShowTnc={setShowTnc}
        />{" "}
      </div>
    </div >
  );
};

export default UpdatedNewCheckoutPage;
